import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";

import HomeView from "../views/Home.vue";
import PreliminaryReportView from "../views/PreliminaryReport.vue";
import ReportView from "../views/Report.vue";
import OrganizationView from "../views/Organization.vue";
import ForbiddenView from "../views/Forbidden.vue";
import LoginView from "../views/Login.vue";
import LogoutView from "../views/Logout.vue";
import AdminView from "../views/Admin.vue";

// import BeforeEach from "./BeforeEach";
import store from "@/store";

Vue.use(VueRouter);

const beforeEnter = async (to: any, from: any, next: any, property: any) => {
  const config = await store.dispatch("App/getConfig").then(config => config);

  if (config[property]) {
    next();
  } else {
    next({ path: "/403" });
  }
};

const routes: Array<RouteConfig> = [
  {
    path: "/",
    // redirect: "/report"
    name: "Home",
    component: HomeView,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/preliminary-report",
    name: "PreliminaryReport",
    component: PreliminaryReportView,
    meta: {
      requiredPerms: "preliminaryReport",
      requiresAuth: true
    }
    // beforeEnter(to, from, next) {
    //   beforeEnter(to, from, next, "canPublishPreliminaryReport");
    // }
  },
  {
    path: "/report",
    name: "Report",
    component: ReportView,
    meta: {
      requiredPerms: "report",
      requiresAuth: true
    }
    // beforeEnter(to, from, next) {
    //   beforeEnter(to, from, next, "canPublishReport");
    // }
  },
  {
    path: "/organization",
    name: "Organization",
    component: OrganizationView,
    meta: {
      requiredPerms: "organization",
      requiresAuth: true
    }
    // beforeEnter(to, from, next) {
    //   beforeEnter(to, from, next, "canPublishReport");
    // }
  },
  {
    path: "/admin",
    name: "Admin",
    component: AdminView,
    meta: {
      requiredPerms: "admin",
      requiresAuth: true
    }
  },
  {
    path: "/403",
    name: "forbidden",
    component: ForbiddenView
  },
  {
    path: "/login",
    name: "login",
    component: LoginView,
    meta: {
      showMenu: false
    }
  },
  {
    path: "/logout",
    name: "logout",
    component: LogoutView,
    meta: {
      showMenu: false
    }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.VUE_APP_BASE_PATH,
  routes
});

const BeforeEach = async (to: any, from: any, next: any) => {
  if (to.meta.requiresAuth) {
    const user = await store.dispatch("User/getCurrent").then(user => user);
    const hasPermissions = to.meta.requiredPerms
      ? user.hasPermission(to.meta.requiredPerms)
      : true;
    // console.log("NAVIGATION");
    // console.log("to", to);
    // console.log("from", from);
    // console.log("user", user);
    // console.log("hasPErmissions", hasPermissions);
    // console.log("-------------------");
    if (user.id && hasPermissions) {
      // console.log("perms ok");
      next();
    } else if (user.id && !hasPermissions) {
      // console.log("=> 403");
      next({
        path: "/403"
      });
    } else {
      // console.log("=> login");
      next({
        path: "/login",
        query: { redirect: to.fullPath }
      });
    }
  } else {
    next();
  }
};

router.beforeEach(BeforeEach);

export default router;
